import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import useStyles from './styles';

const Confirmation = ({message, onSubmit, isBusy, onClose}) => {

  const classes = useStyles();

  const _onSubmit = event => {
    event.preventDefault();
    onSubmit();
  };

  return <form onSubmit={_onSubmit}>
    <Grid container justify='space-around'>
      <Grid item xs={12}>
        <Typography className={classes.text}>
          {message}
        </Typography>
      </Grid>
      {isBusy
        ? <CircularProgress/>
        : <>
          <Grid item>
            <Button color='primary' type='submit'>
              Sim
            </Button>
          </Grid>
          <Grid item>
            <Button color='secondary' onClick={onClose}>
              Fechar
            </Button>
          </Grid>
        </>
      }
    </Grid>
  </form>;
}

export default Confirmation;
